import { CatmullRomCurve3 as _CatmullRomCurve3 } from 'three';

export class CatmullRomCurve3 extends _CatmullRomCurve3
{
    curveType: 'catmullrom' | 'centripetal' | 'chordal';
    closed: boolean;
}
